import { render, staticRenderFns } from "./zhuyuan.vue?vue&type=template&id=0f40eb78&scoped=true&"
import script from "./zhuyuan.vue?vue&type=script&lang=js&"
export * from "./zhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./zhuyuan.vue?vue&type=style&index=0&id=0f40eb78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40eb78",
  null
  
)

export default component.exports